import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { indicatorState } from "../../stores/atoms";
import { awsInstance } from "../../actions/api";
import { thousandFormat, setNameMasking } from "../../actions/utiles";
import { useHistory } from "react-router-dom";

function UseHistoryDetail({ match }) {
  const [, setIndicator] = useRecoilState(indicatorState);
  const reservationId = match.params.id;
  const serviceType = match.params.service_type;
  const [history, setHistory] = useState("");
  const link = useHistory();

  useEffect(() => {
    setIndicator("홈 > 이용 내역 > 이용 내역 조회");

    const getHistoryDetail = async () => {
      try {
        const { data } = await awsInstance.get("/business/history", {
          params: {
            id: reservationId,
            service_type: serviceType
          }
        });
        if (data.code === "SUCCESS") {
          setHistory(data.data);
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      }
    };
    getHistoryDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onReceiptClick = () => {
    if (history.receipt) {
      window.open(history.receipt, '_blank');
    } else {
      alert('매출전표가 없습니다.');
    }
  };

  return (
    <>
      <div className="use_history_detail">
        <h5>이용 내역 조회</h5>
        <table className="table table-detail">
          <tbody>
            <tr>
              <th rowSpan="9" className="width-20">
                <span>운행정보</span>
              </th>
              <td className="width-30 td-second">
                <span>이용번호</span>
              </td>
              <td className="width-60 td-third">
                <span>{serviceType === 0 ? "BC" : serviceType === 1 ? "BR" : "BD"}{reservationId}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>{serviceType === 1 ? "예약접수일시" : "콜 호출일시"}</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.requested_date}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>상품명</span>
              </td>
              <td className="width-60 td-third">
                <span>{serviceType === 0 ? "콜이동" : serviceType === 1 ? "예약이동" : "대리"}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>상태</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.status === 300 ? "운행완료" : "운행취소"}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>탑승일시</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.board_date ? history.board_date : "-"}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>탑승위치</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.start_address}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>도착일시</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.completed_date ? history.completed_date : "-"}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>도착위치</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.end_address}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>이용사유</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.reason ? history.reason : "-"}</span>
              </td>
            </tr>
            <tr>
              <th rowSpan="3" className="width-20">
                <span>직원정보</span>
              </th>
              <td className="width-30 td-second">
                <span>직원 이메일</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.business_user_email}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>직원명</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.business_user_name}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>부서명</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.business_user_department ? history.business_user_department : '-'}</span>
              </td>
            </tr>
            <tr>
              <th className="width-20">
                <span>그룹정보</span>
              </th>
              <td className="width-30 td-second">
                <span>그룹명</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.business_group_name}</span>
              </td>
            </tr>
            <tr>
              <th rowSpan="3" className="width-20">
                <span>차량정보</span>
              </th>
              <td className="width-30 td-second">
                <span>차종</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.vehicle_model}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>차량번호</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.vehicle_type_symbol}{history.vehicle_use_symbol} {history.vehicle_number}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>드라이버 이름</span>
              </td>
              <td className="width-60 td-third">
                <span>
                  {history.driver_name
                    ? setNameMasking(history.driver_name)
                    : "-"}
                </span>
              </td>
            </tr>
            <tr>
              <th rowSpan="6" className="width-20">
                <span>결제금액</span>
              </th>
              <td className="width-30 td-second">
                <span>탑승요금(주차비, 통행료 포함)</span>
              </td>
              <td className="width-60 td-third">
                <span>{thousandFormat(history.total_fare)}원</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>취소 수수료</span>
              </td>
              <td className="width-60 td-third">
                <span>{thousandFormat(history.fee)}원</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>총 이용요금</span>
              </td>
              <td className="width-60 td-third">
                <span className="pr-2">
                  {history.total_fare > 0
                    ? `${thousandFormat(
                        history.total_fare + history.additional_fare
                      )}원`
                    : history.fee > 0
                    ? `${thousandFormat(history.fee)}원`
                    : ""}
                </span>
                {history.is_tax_bill === 0 && <button className="btn-white" onClick={onReceiptClick}>매출전표</button>}
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>결제수단</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.is_tax_bill === 1 ? "세금계산서" : "카드"}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>결제 일시</span>
              </td>
              <td className="width-60 td-third">
                <span>{history.repaid_date ? history.repaid_date : history.completed_date ? history.completed_date : history.canceled_date}</span>
              </td>
            </tr>
            <tr>
              <td className="width-30 td-second">
                <span>결제상태</span>
              </td>
              <td className="width-60 td-third">
                <span>
                  {history.is_tax_bill === 1
                    ? "세금계산서"
                    : history.receipt
                    ? "결제성공"
                    : "결제실패"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="button-area mt-4 txt-center">
          <button
            className="btn-white-md mr-4 font-bold"
            type="button"
            onClick={() => link.goBack()}>
            이전
          </button>
        </div>
      </div>
    </>
  );
}

export default UseHistoryDetail;
